import { createSlice } from '../wrappers';

const initialState = {
	expanded: {
		colorPicker: false,
		vehicleSpecs: true,
	},
	interfaceHidden: false,
};

const menuPanelsSlice = createSlice({
	name: 'menuPanels',
	initialState,
	reducers: {
		setColorPickerExpanded: (state, action) => {
			state.expanded = { vehicleSpecs: false, colorPicker: action.payload };
		},
		setVehicleSpecsExpanded: (state, action) => {
			state.expanded = { colorPicker: false, vehicleSpecs: action.payload };
		},
		setInterfaceHidden: (state, action) => {
			state.interfaceHidden = action.payload;
		},
	},
});

export const {
	setColorPickerExpanded,
	setVehicleSpecsExpanded,
	setInterfaceHidden,
} = menuPanelsSlice.actions;

export default menuPanelsSlice.reducer;
